<div formArrayName="roleUserMapping" class="wk-cm__card-panel__assignees-roleUserMapping">
    @for (role of roles(); track role.Id) {
        @if (showRole()(role.Id)) {
            @let roleMapping = cardDataToShowInModal()?.statusData?.RoleUserMapping?.find((rum) => rum.role.Id === role.Id);
            <div
                [formGroupName]="$index"
                class="wk-cm__card-panel__assignees-roleUserMapping-item"
                [id]="(type() ?? 'assignee') + '_role_' + role.Id"
            >
                <label [class.highlighted]="cardDataToShowInModal()?.statusData?.Role && role.Id === cardDataToShowInModal()?.statusData?.Role.Id">
                    {{ role.Description | wkTranslate }}
                </label>
                <kendo-dropdownlist-wrapper
                    [data]="usersPerRole().get(role.Id) ?? []"
                    formControlName="userId"
                    textField="label"
                    [valueField]="useiFirmUserId() ? 'iFirmUserId' : 'id'"
                    [virtual]="true"
                    [value]="roleMapping?.userId"
                    [readonly]="isPartnerOrManagerRoleDisabled()(role)"
                    [tooltipIfReadonly]="'Tooltips.DisabledPartnerManager' | translate"
                />
            </div>
        }
    }
</div>
